import { createFileRoute } from '@tanstack/react-router';
import JobViewContent from '../jobs/view/job-details/job-view-content';

export const Route = createFileRoute('/orders/$orderGuid_/jobs/$jobGuid/')({
  component: JobViewContent,
});
